const NON_SPELLCHECK_INPUT_TYPES = new Set([
  'button',
  'checkbox',
  'color',
  'date',
  'datetime-local',
  'email',
  'file',
  'hidden',
  'month',
  'number',
  'password',
  'radio',
  'range',
  'reset',
  'search',
  'submit',
  'tel',
  'time',
  'url',
  'week',
])

const SPELLCHECK_TARGET_SELECTOR =
  'input, textarea, [contenteditable="true"], .ProseMirror'

function hasExplicitSpellcheckPreference(element: HTMLElement) {
  return (
    element.hasAttribute('spellcheck') ||
    element.dataset.spellcheckManaged === 'true'
  )
}

function shouldEnableInputSpellcheck(input: HTMLInputElement) {
  const type = (input.getAttribute('type') || 'text').toLowerCase()

  return !NON_SPELLCHECK_INPUT_TYPES.has(type)
}

function applySpellcheck(element: Element) {
  if (!(element instanceof HTMLElement)) return
  if (hasExplicitSpellcheckPreference(element)) return

  if (
    element instanceof HTMLInputElement &&
    !shouldEnableInputSpellcheck(element)
  ) {
    element.spellcheck = false
    element.dataset.spellcheckManaged = 'true'
    return
  }

  element.spellcheck = true
  element.dataset.spellcheckManaged = 'true'
}

function applySpellcheckIn(root: ParentNode) {
  if (root instanceof Element) {
    applySpellcheck(root)
  }

  root.querySelectorAll(SPELLCHECK_TARGET_SELECTOR).forEach(applySpellcheck)
}

function applyFocusedSpellcheck(event: FocusEvent) {
  const target =
    event.target instanceof Element
      ? event.target.closest(SPELLCHECK_TARGET_SELECTOR)
      : null

  if (target) {
    applySpellcheck(target)
  }
}

export function enableNaturalLanguageSpellcheck() {
  document.documentElement.lang ||= 'en'
  document.documentElement.spellcheck = true
  document.body.spellcheck = true

  applySpellcheckIn(document)
  document.addEventListener('focusin', applyFocusedSpellcheck)

  return () => document.removeEventListener('focusin', applyFocusedSpellcheck)
}
